module.exports = __webpack_public_path__ + "static/media/document-week7.4f05402e.pdf";